module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_japones.db24f9a8.png";